import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";

import GaugeIcon from "../assets/checklist/Gauge-Page-icon.svg";
import ScoreboardIcon from "../assets/checklist/scoreboard-icon-tab.svg";
import Sidebar from "../Components/Sidebars/main";
import NavBar from "../Components/Navbars/main";
import ActionBarComponent from "../Components/common/ActionBarComponent";
import Footer from "../Components/common/footer";
import { useCaseTypeData } from "../Components/CheckLists/new-checklist/hooks/useCaseTypeData";
import NewTabs from "../Components/new-client-dashboard/NewTabs";
import { MyVerticallyCenteredModal } from "../Components/CheckLists/EditCheckListModal";
import "./NewChecklist.css";
import CircularGauge from "../Components/CheckLists/new-checklist/CircularGauge";
import { fetchPageObject, fetchShakespeareStatus, getCaseId } from "../Utils/helper";
import NewChangesTabs from "../Components/new-client-dashboard/NewChangesTabs";
import ScoreboardConfigModal from "../Components/CheckLists/new-checklist/scoreboard-modal";

const NewChecklistPage = () => {
  const [duration, setDuration] = useState("all");
  // const [_page, setPage] = useState("");
  const dispatch = useDispatch();
  const caseId = getCaseId();
  const [pageObject, setPageObject] = useState(null);
  const [scoreboardModalShow, setScoreboardModalShow] = useState(false);
  useEffect(() => {
    if (caseId && !pageObject) {
      fetchPageObject(caseId, 44).then((data) => {
        setPageObject(data);
      });
    }
  }, [caseId, pageObject]);

  // const handlePageChange = useCallback((page) => {
  //   setPage(page);
  // }, []);

  const handleFilterChange = useCallback((filter) => {
    setDuration(filter);
  }, []);
  const { allFirmCasetypeImageList, pagesList, pagePercentages, fetchCompleteData, isLoading } =
    useCaseTypeData();

  const [modalShow, setModalShow] = useState(false);
  const [selectedCheck, setSelectedCheck] = useState();
  const handleClose = () => setModalShow(false);
  const handleShow = () => setModalShow(true);

  useEffect(() => {
    fetchCompleteData(duration);
    // sending page ids directly now.
    fetchShakespeareStatus(getCaseId(), 44, dispatch);
  }, [duration, fetchCompleteData]);

  const tabsData = [
    {
      id: "all",
      label: "Any Case Age",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      onClick: () => handleFilterChange("all"),
      leftHand: false,
    },
    {
      id: "90",
      label: "> 90 Days",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      onClick: () => handleFilterChange("90"),
      leftHand: false,
    },

    {
      id: "60",
      label: "> 60 Days",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      onClick: () => handleFilterChange("60"),
      leftHand: false,
    },

    {
      id: "30",
      label: "> 30 Days",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      onClick: () => handleFilterChange("30"),
      leftHand: false,
    },

    {
      id: "15",
      label: "> 15 Days",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      onClick: () => handleFilterChange("15"),
      leftHand: false,
    },
  ];

  const viewTabs = [
    {
      id: "scoreboard",
      label: "Scoreboard",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-60)",
      activeColor: "white",
      onClick: () => setScoreboardModalShow(true),
      leftHand: true,
      span: (
        <span
          className="ic-avatar ic-15"
          style={{
            width: "15px",
            height: "15px",
          }}
        >
          <img src={ScoreboardIcon} width="25" alt="Chat" />
        </span>
      ),
    },
  ];
  const mainRef = useRef(null);
  const containerRef = useRef(null);
  const [rowCount, setRowCount] = useState(0);

  useEffect(() => {
    const calculateRows = () => {
      if (
        pagesList.length === 0 ||
        pagePercentages.length === 0 ||
        allFirmCasetypeImageList.length === 0
      ) {
        return;
      }

      const mainHeight = mainRef.current?.offsetHeight || 0;
      const containerHeight = (allFirmCasetypeImageList?.length + 1) * 50 || 0;
      const availableHeight = mainHeight - containerHeight - 50;

      const rows = Math.floor(availableHeight / 50);

      setRowCount(rows);
    };

    calculateRows();

    window.addEventListener("resize", calculateRows);

    return () => {
      window.removeEventListener("resize", calculateRows);
    };
  }, [pagesList, containerRef, pagePercentages, allFirmCasetypeImageList]);

  const adjustCaseDetailsWidths = () => {
    const leftColumns = document.querySelectorAll(".gauge-page-case-types");
    const rightColumns = document.querySelectorAll(".gauge-page-types");

    let maxLeftWidth = 0;
    let maxRightWidth = 1000;
    leftColumns.forEach((column) => {
      const width = column.getBoundingClientRect().width;
      maxLeftWidth = Math.max(maxLeftWidth, width);
    });

    leftColumns.forEach((column) => {
      column.style.width = `${maxLeftWidth}px`;
    });

    rightColumns.forEach((column) => {
      const width = column.getBoundingClientRect().width;
      maxRightWidth = Math.min(maxRightWidth, width);
    });

    rightColumns.forEach((column) => {
      column.style.width = `${maxRightWidth}px`;
    });
  };

  useEffect(() => {
    adjustCaseDetailsWidths();
    window.addEventListener("resize", adjustCaseDetailsWidths);
    return () => {
      window.removeEventListener("resize", adjustCaseDetailsWidths);
    };
  }, [pagesList]);

  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);

  return (
    <>
      <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
        <Sidebar />
        <div className="page-container overflow-hidden">
          <NavBar flaggedPageName={"44"} />
          <ActionBarComponent
            page_name={pageObject?.name}
            pageObj={pageObject}
            isChecklist={pageObject?.PageChklst || false}
            src={GaugeIcon}
          />
          <div className="TreatmentPage-main-container invisible-scrollbar" ref={mainRef}>
            {/*  */}
            <div className="d-flex align-items-center ">
              <div className="w-100 d-flex align-items-center justify-content-start">
                {/* <NewTabs tabsData={tabsData} currentTab={duration} /> */}
                <NewChangesTabs
                  currentTab={duration}
                  tabsData={tabsData}
                  height={25}
                  labelClass=" justify-content-start pe-2"
                  // widthTab={true}
                  // mainContainerClass="pe-0"
                />
              </div>
              <div className="w-100 d-flex align-items-center justify-content-between">
                <NewTabs
                  tabsData={viewTabs}
                  containerClass="ps-3 pe-3"
                  currentTab={duration}
                  popupTabs={true}
                />
              </div>
            </div>
            {isLoading ? (
              <></>
            ) : (
              <div
                className="tab-pane active show"
                id="custom-nav-all"
                role="tabpanel"
                aria-labelledby="custom-nav-all-tab"
                ref={containerRef}
              >
                <div className="table--no-card rounded-0 border-0 w-100" id="table-height ">
                  <table
                    className="table table-borderless table-navi-different  has-height-25 fixed-table-header-notes-page"
                    id="table-x-notes"
                  >
                    <thead className="toolbar-fonts">
                      <tr
                        id=""
                        style={{
                          color: "white",
                          textTransform: "uppercase",
                        }}
                      >
                        <th
                          style={{
                            // background: "var(--primary-15)",
                            // width: "160px",
                            width: "105px",
                            textAlign: pagesList.length > 0 ? "center" : "start",
                          }}
                          className="text-center bg-primary-5 gauge-page-case-types color-primary c-font-weight-600"
                        >
                          Case Type
                        </th>

                        {pagesList
                          .sort((a, b) => a.order - b.order)
                          .map((page) => {
                            return (
                              <th
                                style={{
                                  // background: "var(--primary-15)",
                                  flex: "1 1 auto",
                                }}
                                key={page.id}
                                className="bg-primary-5 text-start gauge-page-types color-primary c-font-weight-600"
                              >
                                <div
                                  className="d-flex height-21 align-items-center justify-content-center"
                                  style={{
                                    gap: "5px",
                                  }}
                                >
                                  <span className="d-flex align-items-center justify-content-center">
                                    <img
                                      className="d-flex align-items-center justify-content-center"
                                      src={page?.pageIcon || ""}
                                      alt={page?.name}
                                      style={{ width: "15px", height: "15px" }}
                                      // title={page?.name} // Show full name on hover
                                    />
                                  </span>
                                  <span
                                    className="page-name"
                                    style={{
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {page.name}
                                  </span>
                                </div>
                              </th>
                            );
                          })}
                      </tr>
                    </thead>
                    <tbody id="table-body-cat" className="all_notes_tab fixed_column_width">
                      <tr
                        style={{
                          cursor: "pointer",
                        }}
                      >
                        <td className="text-nowrap  gauge-page-case-types text-align-center check-list-center">
                          <div className="d-flex align-items-center justify-content-center">
                            <span
                              className="d-inline-block"
                              style={{
                                fontWeight: "600",
                                color: "var(--primary)",
                              }}
                            >
                              All Case Types
                            </span>
                          </div>
                        </td>
                        {/* <td /> */}

                        {/* Render gauges for all pages - "All" case type */}
                        {pagesList
                          .sort((a, b) => a.order - b.order)
                          .map((page, idx) => {
                            const allCaseTypeData = pagePercentages.find(
                              (pageData) => pageData.caseType === "All"
                            );
                            const pagePercentageData = allCaseTypeData?.percentages?.find(
                              (p) => p.pageName === page.name
                            );
                            const percentage = pagePercentageData?.percentage;

                            return (
                              <td
                                key={idx}
                                onClick={() => {
                                  if (pagePercentageData) {
                                    setSelectedCheck({
                                      ...pagePercentageData,
                                      caseType: "All",
                                    });
                                    handleShow();
                                  }
                                }}
                                className="onHoverNewThings"
                              >
                                <div className="avg-checklist-div d-flex align-items-center justify-content-center text-align-center mx-auto">
                                  <CircularGauge
                                    percentage={
                                      percentage !== null && percentage !== undefined
                                        ? percentage
                                        : 0
                                    }
                                  />
                                </div>
                              </td>
                            );
                          })}
                      </tr>

                      {allFirmCasetypeImageList?.map((caseItem, index) => (
                        <tr
                          style={{
                            height: "50px",
                            cursor: "pointer",
                          }}
                          key={index}
                        >
                          <td className="text-nowrap gauge-page-case-types text-align-center check-list-center">
                            <div
                              className="d-flex align-items-center justify-content-start"
                              style={{
                                gap: "5px",
                              }}
                            >
                              {caseItem.image && (
                                <img
                                  src={`${caseItem.image}`}
                                  alt=""
                                  style={{ width: "15px", height: "15px", cursor: "pointer" }}
                                  className="d-flex align-items-center justify-content-center me-0 ic ic-19"
                                />
                              )}
                              <span
                                style={{
                                  fontWeight: "600",
                                  color: "var(--primary)",
                                }}
                                className="d-inline-block"
                              >
                                {caseItem.name}
                              </span>
                            </div>
                          </td>
                          {/* <td /> */}

                          {/* Render gauges for all pages - each case type */}
                          {pagesList
                            .sort((a, b) => a.order - b.order)
                            .map((page, idx) => {
                              const caseTypeData = pagePercentages.find(
                                (pageData) => pageData.caseType === caseItem.name
                              );
                              const pagePercentageData = caseTypeData?.percentages?.find(
                                (p) => p.pageName === page.name
                              );
                              const percentage = pagePercentageData?.percentage;

                              return (
                                <td
                                  key={idx}
                                  onClick={() => {
                                    if (pagePercentageData) {
                                      setSelectedCheck({
                                        ...pagePercentageData,
                                        caseType: caseItem.name,
                                      });
                                      handleShow();
                                    }
                                  }}
                                  className="onHoverNewThings"
                                >
                                  <div className="avg-checklist-div d-flex align-items-center justify-content-center text-align-center d-flex align-items-center">
                                    <CircularGauge
                                      percentage={percentage !== undefined ? percentage : 0}
                                    />
                                  </div>
                                </td>
                              );
                            })}
                        </tr>
                      ))}

                      {Array.from({ length: rowCount }, (_, index) => (
                        <tr
                          key={`fake-row-${rowCount + index}`}
                          className="fake-row-2"
                          style={{ height: "50px" }}
                        >
                          <td
                            colSpan={pagesList.length + 1 || 9}
                            id="clientHistoryCaseIconPadding"
                            style={{ height: "50px" }}
                          >
                            &nbsp;
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <Footer />
      {scoreboardModalShow && (
        <ScoreboardConfigModal
          show={scoreboardModalShow}
          onHide={() => setScoreboardModalShow(false)}
          onGenerate={({ teams, firmUsers }) => {
            // TODO: navigate to scoreboard view / call API with selection
            // eslint-disable-next-line no-console
            console.log("generate scoreboard", { teams, firmUsers });
          }}
        />
      )}
      {modalShow && (
        <MyVerticallyCenteredModal
          selectedCheck={selectedCheck}
          show={modalShow}
          handleClose={handleClose}
          duration={duration}
        />
      )}
    </>
  );
};

export default NewChecklistPage;
